import { formTypeAddModalHide, formTypeAddModalShow, formTypeFilesModalHide, formTypeFilesModalShow } from '../actions/formTypeActions';
import { createOdooForm, removeOdooForm } from '../actions/odooFormActions';
import { getUserDetails } from '../actions/userActions';
import { formatDate } from '../utils/formTypeUtils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

export function useFormType(sessionId) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formType = useSelector((state) => state.formType);
  const showFilesPopup = formType.showFilesPopup;
  const showAddPopup = formType.showAddPopup;
  const anyModalOpen = Boolean(showFilesPopup || showAddPopup);

  useEffect(() => {
    dispatch(getUserDetails(sessionId));
  }, [dispatch, sessionId]);

  useEffect(() => {
    if (!anyModalOpen) {
      return undefined;
    }
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [anyModalOpen]);

  useEffect(() => {
    if (!anyModalOpen) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        dispatch(formTypeFilesModalHide());
        dispatch(formTypeAddModalHide());
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [anyModalOpen, dispatch]);

  const hideFilesModal = () => dispatch(formTypeFilesModalHide());
  const hideAddModal = () => dispatch(formTypeAddModalHide());

  const fileDownloadHandler = (file) => {
    dispatch(formTypeFilesModalHide());

    window.location.pathname = `/registry/api/v1/file/${file.id}`;
  };

  const filesClickHandler = (files) => {
    dispatch(formTypeFilesModalShow(files));
  };

  const deleteClickHandler = (formTypeId, formId, name, date) => {
    if (!window.confirm(`Delete "${name}" (${formatDate(date)})?`)) return;
    dispatch(removeOdooForm(sessionId, formTypeId, formId));
  };

  const addClickHandler = (addTypes, type, breadcrumbs, config) => {
    if (config.addRedirects?.[type]) {
      window.location.pathname = config.addRedirects[type];
      return;
    }
    if (!addTypes?.length) return;
    if (addTypes.length === 1) return addFormHandler(addTypes[0].id, breadcrumbs, config);
    dispatch(formTypeAddModalShow());
  };

  const addFormHandler = (formTypeId, breadcrumbs) => {
    dispatch(
      createOdooForm(sessionId, formTypeId, navigate, (formType, formId) => {
        dispatch(formTypeAddModalHide());
        if (formType && formId) {
          navigate(`/form/${formType}/${formId}`, { state: { breadCrumbs: breadcrumbs } });
        } else if (formType) {
          navigate(`/forms/${formType}`, { state: { breadCrumbs: breadcrumbs } });
        } else {
          navigate('/');
        }
      }),
    );
  };

  return {
    fileDownloadHandler,
    filesClickHandler,
    deleteClickHandler,
    addClickHandler,
    addFormHandler,
    hideFilesModal,
    hideAddModal,
  };
}
